var map = {
	"./en/translation.json": [
		5544,
		5544
	],
	"./ja/translation.json": [
		71886,
		1886
	],
	"./ko/translation.json": [
		68773,
		8773
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10350;
module.exports = webpackAsyncContext;